import React, { useState, useEffect, Suspense, lazy } from 'react';
import { Routes, Route } from "react-router-dom";
import ErrorBoundary from './dev/common/ErrorBoundary'
import Topbar from "./dev/menu/scenes/global/Topbar";
import Sidebar from "./dev/menu/scenes/global/Sidebar";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./dev/menu/theme";
import Loader from './dev/menu/Ui/loader';
// import Dashboard from './dev/menu/scenes/dashboard';
// import CreateUser from './dev/userm/CreateUser';

const Dashboard = lazy(() => import('./dev/menu/scenes/dashboard'))
const RODashBoard = lazy(() => import('./dev/RODashBoard/RODashBoard'))
const OrderGeneration = lazy(() => import('./dev/orderm/orderGeneration'))
const CheckTransportStatus = lazy(()=>import('./dev/orderm/CheckTransportStatus'))
const OrderGenerationAll = lazy(() => import('./dev/orderm/orderGenerationAll'))
const Completedorders = lazy(() => import('./dev/orderm/orderGeneration/completed'))
const OrderApproval = lazy(() => import('./dev/orderm/orderGeneration/orderapprovals'))
const NewProcurement = lazy(() => import('./dev/orderm/procurement'))
const ReceiverAllocation = lazy(() => import('./dev/orderm/receiverallocation'))
const LoanSenderAllocation = lazy(() => import('./dev/orderm/receiverallocation/loanordersenderallocate'))
const SenderAllocation = lazy(() => import('./dev/orderm/senderallocation'))
const MFAReceiverAllocation = lazy(() => import('./dev/orderm/senderallocation/mfareceiverallocation'))
const MFASenderAllocation = lazy(() => import('./dev/orderm/senderallocation/mfasenderallocation'))
const CreateOrder = lazy(() => import('./dev/orderm/createOrder/createorder'))
const MergeOrder = lazy(() => import('./dev/orderm/mergeorders'))
const StockOrder = lazy(() => import('./dev/orderm/stockorders'))
const OrderHistory = lazy(() => import('./dev/orderm/orderHistory'))
const PendingActions = lazy(() => import('./dev/orderm/pendingActions'))
const Physicalverification = lazy(() => import('./dev/orderm/physicalverification'))
const CreateVerification = lazy(() => import('./dev/orderm/physicalverification/createverification'))
const UserAssign = lazy(() => import('./dev/orderm/userassign'))
const RollBacking = lazy(() => import('./dev/orderm/RollBacking/index'))
const ChangeWarehouse = lazy(()=>import('./dev/otheraggregateservices/ChangeWarehouse/ChangeWarehouse'))
const UnitOrderSearch = lazy(() => import('./dev/orderm/unitOrderSearch/index'))
const FAQ = lazy(() => import('./dev/menu/scenes/faq'))
const FlcPrepadness = lazy(() => import('./dev/unitm/FlcPrepadness'))
const Flcprocess = lazy(() => import('./dev/unitm/Flcprocess'))
const FlcStatus = lazy(() => import('./dev/unitm/FlcStatus'))
const ElectionSchedule = lazy(() => import('./dev/unitm/ElectionSchedule'))
const CreateNewFLCSchedule = lazy(() => import('./dev/unitm/CreateNewFLCSchedule'))
const Flcscheduling = lazy(() => import('./dev/unitm/Flcscheduling'))
const ViewFLCList = lazy(() => import('./dev/unitm/ViewFLCList'))
const Create1stRandomizationSchedule = lazy(() => import('./dev/unitm/Create1stRandomizationSchedule'))
const FirstRandomization = lazy(() => import('./dev/unitm/FirstRandomization'))
const SecondRandomization = lazy(() => import('./dev/unitm/SecondRandomization'))
const RandomizationReadiness = lazy(()=>import('./dev/unitm/RandomizationReadiness'))
// const RandomizationMap = lazy(()=>import('./dev/unitm/RandomizationMap'))
const SecondRandomizationSchedule = lazy(() => import('./dev/unitm/SecondRandomizationSchedule'))
const FirstRandomizationSchedule = lazy(() => import('./dev/unitm/FirstRandomizationSchedule'))
const Distributing = lazy(() => import('./dev/unitm/Distributing'))
const Polling = lazy(() => import('./dev/unitm/Polling'))
const Counting = lazy(() => import('./dev/unitm/Counting'))
const Training = lazy(() => import('./dev/unitm/Training'))
const ChangeUnitStatus = lazy(() => import('./dev/unitm/ChangeUnitStatus'))
const ChangeUnitWarehouseToWarehouse = lazy(() => import('./dev/unitm/ChangeUnitWarehouseToWarehouse'))
const ElectionPetition = lazy(() => import('./dev/unitm/ElectionPetition'))
const ElectionPetitionView = lazy(() => import('./dev/unitm/ElectionPetitionView.js'))
const EPMarkDetailedReport = lazy(() => import('./dev/unitm/EPMarkDetailedReport.jsx'))
const Physicalverificstion = lazy(() => import('./dev/unitm/Physicalverificstion'))
const Others = lazy(() => import('./dev/unitm/Others'))
const BlockUnits = lazy(() => import('./dev/unitm/BlockUnits'))
const ChangeBoxID = lazy(() => import('./dev/unitm/ChangeBoxID'))
const UnBlockUnits = lazy(() => import('./dev/unitm/UnBlockUnits'))
const DestroyUnits = lazy(() => import('./dev/unitm/DestroyUnits'))
const Consumable = lazy(() => import('./dev/consumablem/consumable'))
const Commissioning = lazy(() => import('./dev/unitm/Commissioning'))
const CreateUser = lazy(() => import('./dev/userm/CreateUser'))
const WarehouseList = lazy(() => import('./dev/warehousestrongroomm/WarehouseList'))
const Strongroom = lazy(() => import('./dev/warehousestrongroomm/Strongroom'))
const AddWarehouse = lazy(() => import('./dev/warehousestrongroomm/AddWarehouse'))
const AuditDetail = lazy(() => import('./dev/warehousestrongroomm/auditpage'))
const WarehouseDetail = lazy(() => import('./dev/warehousestrongroomm/WarehouseDetail'))
const ModifyWarehouse = lazy(() => import('./dev/warehousestrongroomm/ModifyWarehouse'))
const UnitReplacement = lazy(() => import('./dev/unitm/UnitReplacement'))
const UnitReplacementAgainstSOP = lazy(() => import('./dev/unitm/UnitReplacementAgainstSoP'))
const UnitReplacementRollback = lazy(() => import('./dev/unitm/UnitReplacementRollback'))
const CreateIssue = lazy(() => import('./dev/issuem/CreateIssue'))
const ManageUsers = lazy(() => import('./dev/userm/ManageUsers'))
const RequestList = lazy(() => import('./dev/issuem/Requestlist'))
const FaqPage = lazy(() => import('./dev/issuem/FaqPage'))
const GLobalSearch = lazy(() => import('./dev/otheraggregateservices/globalSearch'))
const FLCNonFunctional = lazy(() => import('./dev/otheraggregateservices/FLCNonFunctional/index'))
const MasterManagementModule = lazy(() => import('./dev/otheraggregateservices/masterManagementModule'))
const OAFLCStatus = lazy(() => import('./dev/otheraggregateservices/OAFLCStatus'))
const FLCStetewiseStatus = lazy(()=>import('./dev/otheraggregateservices/FLCStatewiseStatus'))
const ElectionDetails = lazy(()=>import('./dev/otheraggregateservices/ElectionDetails'))
const OARandomizationStatus = lazy(() => import('./dev/otheraggregateservices/RandomizationStatus/MainDataRandomization'))
const RandDuplicateChecking = lazy(() => import('./dev/otheraggregateservices/RandDuplicateChecking'))
const ViewUnitReplacementAgainstSoP = lazy(() => import('./dev/otheraggregateservices/ViewUnitReplacementAgainstSoP'))
const EVMCheckandVerification = lazy(() => import('./dev/otheraggregateservices/EVMCheckandVerification.jsx'))
const CandVUpdate = lazy(() => import('./dev/otheraggregateservices/CandVUpdate.jsx'))
const EVMCandVRemove = lazy(() => import('./dev/otheraggregateservices/CandVRemove.jsx'))
const GetOTP = lazy(() => import('./dev/otheraggregateservices/GetOtp'))
const OverallUnitReplacementStatus = lazy(()=>import('./dev/otheraggregateservices/OverallUnitReplacementStatus'))
const ScanningStatus = lazy(() => import('./dev/otheraggregateservices/ScanningStatus'))
// const EPStatus = lazy(() => import('./dev/otheraggregateservices/EPStatus'))
const WarehouseInspectionStatus = lazy(() => import('./dev/otheraggregateservices/WarehouseInspectionStatus'))
const WarehouseInspectionManage = lazy(() => import('./dev/otheraggregateservices/WarehouseInspectionManage'))
// const LoggedUsersStatus = lazy(() => import('./dev/otheraggregateservices/LoggedUsersStatus'))
const RandomizationRollBack = lazy(() => import('./dev/unitm/RandomizationRollBack'))
const OrderRollBack = lazy(() => import('./dev/orderm/OrderRollBack/OrderRollBack'))
const UnitOrderRollBack = lazy(() => import('./dev/orderm/UnitOrderRollBack.jsx'))
const CandidateDetails = lazy(() => import('./dev/unitm/CandidateDetails'))
const RolesPermissions = lazy(() => import('./dev/RolesPermissions'))
const ViewEditmaster = lazy(() => import('./dev/otheraggregateservices/view'))
const MoveWHtoWHUnits = lazy(() => import('./dev/otheraggregateservices/MoveWHtoWHUnits/MoveWHtoWHUnits'))
const NRVRollback = lazy(() => import('./dev/orderm/NRVRollBack'))
const UploadRepairedCertificate = lazy(() => import('./dev/otheraggregateservices/UploadRepairedCertificate/UploadRepairedCertificate'))
const Viewrepairedcertificate = lazy(() => import('./dev/otheraggregateservices/UploadRepairedCertificate/viewrepairedcertificate'))
const FormPropsTextFields = lazy(() => import('./dev/userm/Changepassword'))
const Calendar = lazy(() => import('./dev/menu/scenes/calendar/calendar'))
const Approval = lazy(() => import('./dev/warehousestrongroomm/Approval'))
const TentativeElectionSchedule = lazy(() => import('./dev/unitm/TentativeElectionSchedule'))
const UserReport = lazy(() => import('./dev/reports/UserReport'))
const Allreports = lazy(() => import('./dev/reports/Allreports'))
const OrderReport = lazy(() => import('./dev/reports/OrderReport'))
const UnitReport = lazy(() => import('./dev/reports/UnitReport'))
const ArchiveUnitReport = lazy(() => import('./dev/reports/ArchiveUnitReports'))
const WarehouseReport = lazy(() => import('./dev/reports/WarehouseReport'))
const IssueReport = lazy(() => import('./dev/reports/IssueReport'))
const ConsumableReport = lazy(() => import('./dev/reports/ConsumableReport'))
const AcAllocation = lazy(() => import('./dev/unitm/acAllocation'))
const PcAllocation = lazy(() => import('./dev/unitm/PcAllocation'))
const FLCPreparednessDEO = lazy(() => import('./dev/unitm/FLCPreparednessDEO'))
const AdminUtilities = lazy(() => import('./dev/AdminUtilities/Utilities'))
const StateName = lazy(() => import('./dev/AdminUtilities/Utilities/StateName')) 
const DistrictData = lazy(() => import('./dev/AdminUtilities/Utilities/Dist'))
const AC = lazy(() => import('./dev/AdminUtilities/Utilities/AC'))
const PC = lazy(() => import('./dev/AdminUtilities/Utilities/PC'))
const PSList = lazy(() => import('./dev/AdminUtilities/Utilities/PSList'))
const PageNotFound = lazy(() => import('./dev/common/PageNotFound'))
const TnAlist = lazy(() => import('./dev/unitm/TnAlist'))
const MapData = lazy(() => import('./dev/otheraggregateservices/MapData'))
const WareHouseTypes = lazy(() => import('./dev/AdminUtilities/Utilities/WareHouseTypes'))
const DefectiveTypes = lazy(() => import('./dev/AdminUtilities/Utilities/DefectiveTypes'))
const Unittypeandmodel = lazy(() => import('./dev/AdminUtilities/Utilities/unittypeandmodel'))
const ManufacturerDashboard = lazy(() => import('./dev/menu/scenes/manufacturerdashboard/TotalData'))
const DispatchedUnits = lazy(() => import('./dev/otheraggregateservices/DispatchedUnits/DispTotalData'))
const BarCode = lazy(() => import('./dev/otheraggregateservices/BarCode/BarCode'))
const PersonnelRegistration = lazy(() => import('./dev/otheraggregateservices/Tracking/PersonnelRegistration/PersonnelRegistration'))
const PersonnelTracking = lazy(() => import('./dev/otheraggregateservices/Tracking/PersonnelTracking/PersonnelTracking'))
const VehilceTracking = lazy(() => import('./dev/otheraggregateservices/Tracking/VehicleTracking/VehicleTracking'))
const OptimalMap = lazy(() => import('./dev/otheraggregateservices/Tracking/VehicleTracking/OptimalMap'))
const TrackingHistory = lazy(() => import('./dev/otheraggregateservices/Tracking/trackingHistory/TrackingHistory'))
const PermissionDenied=lazy(()=>import('./dev/common/PermissionDenied'))
const PollingStation = lazy(() => import('./dev/unitm/PollingStation/PollingStation'))
const ExpiredConsumables = lazy(() => import('./dev/consumablem/ExpiredConsumables/ExpiredConsumables'))
const ExpiringConsumables = lazy(() => import('./dev/consumablem/ExpiringConsumables/ExpiringConsumables'))
const NewStockEntry = lazy(() => import('./dev/consumablem/NewStockEntry/NewStockEntry'))
const SenderReport = lazy(() => import('./dev/reports/SenderReport'))
const ReceiverReport = lazy(() => import('./dev/reports/ReceiverReport'))
const StateWiseReport = lazy(() => import('./dev/reports/StateWiseReport'))
const ManufacturerReport = lazy(() => import('./dev/reports/ManufacturerReport'))
const OrderScanningReport = lazy(() => import('./dev/reports/OrderScanningReport'))
const ManufacturerWiseReport = lazy(() => import('./dev/reports/ManufacturerWiseReport'))
const ManufacturerStockYearReport = lazy(() => import('./dev/reports/ManufacturerStockYearReport'))
const StateWiseNonFunc = lazy(() => import('./dev/reports/StateWiseNonFunc'))
const FLCScanningReport = lazy(() => import('./dev/reports/FLCScanningReport'))
const UserManual = lazy(() => import('./dev/UserManual/UserManual'))
const DisplayAnnouncement = lazy(() => import('./dev/AdminUtilities/Utilities/DisplayAnnouncement'))
const TandAMaster = lazy(() => import('./dev/AdminUtilities/Utilities/T&A_Master'));
const NonFunctionalStatus = lazy(()=>import('./dev/otheraggregateservices/NonFunctionalStatus'))
const RepairedUnitsDetails = lazy(() => import('./dev/otheraggregateservices/RepairedUnitsDetails/RepairedUnitsDetails.jsx'))
const UnitReplacementHistory = lazy(() => import('./dev/otheraggregateservices/UnitReplacementHistory'))
const ViewBoxInfo = lazy(() => import('./dev/otheraggregateservices/ViewBoxInfo'))
const NonFunctionalReserveRollback = lazy(() => import('./dev/unitm/NonFunctionalReserveRollback'))
const EVMViewCandV = lazy(()=>import('./dev/otheraggregateservices/EVMViewCandV.jsx'))
const EVMViewCandVFinal = lazy(()=>import('./dev/otheraggregateservices/EVMViewCandVFinal.jsx'))
const MandatoryVerificationOfVVPAT = lazy(()=>import('./dev/unitm/MandatoryVerificationOfVVPAT.jsx'))
const VVPATView = lazy(()=>import('./dev/unitm/VVPATView.jsx'))


function Routed(props) {
	const [theme, colorMode] = useMode();
	const [isSidebar, setIsSidebar] = useState(false);
	const [maintaskcode, setmaintaskcode] = useState([]);
	const [subtaskcodes, setsubtaskcodes] = useState([]);
	const userId = sessionStorage.getItem('sessionToken');
	let roleCode="";
	if ((userId !== undefined) && (userId !== null))
	{
		roleCode=userId.slice(8,11);
	}
	const mainTasks = JSON.parse(localStorage.getItem("main_task"));
	const subTasks = JSON.parse(localStorage.getItem("sub_tasks"));
	var code = [];
	var subcode = [];

	useEffect(() => {
		mainTasks[0].forEach((ele) => {
		  code.push(ele.split(":")[0]);
		  setmaintaskcode(...maintaskcode, code);
		}, []);
	
		subTasks.forEach((element) => {
		  subcode.push(String(element).split(":")[0]);
		  setsubtaskcodes(...subtaskcodes, subcode);
		});
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
		<ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Sidebar isSidebar={isSidebar} setIsSidebar={setIsSidebar}  />
        <main className="content">
					<Topbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
					<ErrorBoundary>
					  <Suspense fallback={<center style={{marginTop: "40vh"}}><Loader/></center>}>
            <Routes>
							<Route path="/home" element={<Dashboard />} />
							<Route path="/RODashBoard" element={<RODashBoard />} />
							<Route path="/UserManual" element={<UserManual />} />
							<Route path="/manufacturerdashboard" element={<ManufacturerDashboard />} />
							<Route path="/FLCSchedule" element={<Flcscheduling />} />
							<Route path="/FLCProcess" element={<Flcprocess />} />
							<Route path="/FlcStatus" element={<FlcStatus />} />
							<Route path="/ElectionSchedule" element={<ElectionSchedule />} />
							<Route path="/ViewFLCList" element={<ViewFLCList />} />
							<Route path="/CreateNewFLCSchedule" element={<CreateNewFLCSchedule />} />
							<Route path="/FLCPrepadness" element={<FlcPrepadness />} />
							<Route path="/FLCPrepadnessDEO" element={<FLCPreparednessDEO/>} />
							<Route path="/Create1stRandomizationSchedule" element={<Create1stRandomizationSchedule />} />
							<Route path="/firstRandomizationSchedule" element={<FirstRandomizationSchedule />} />
							<Route path="/FirstRandomizationProcess/:id/:eid/:eleid" element={<FirstRandomization />} />
							<Route path="/rollback" element={<RandomizationRollBack />} />	
							<Route path="/OrderRollBack" element={<OrderRollBack />} />
							<Route path="/UnitOrderRollBack" element={<UnitOrderRollBack />} />
							<Route path="/CandidateDetails" element={<CandidateDetails />} />
							<Route path="/SecondRandomizationSchedule" element={<SecondRandomizationSchedule />} />
							<Route path="/RandomizationReadiness" element={<RandomizationReadiness/>} />
							{/* <Route path="/RandomizationMap" element={<RandomizationMap/>} /> */}

							<Route path="/SecondRandomizationProcess/:id/:eid/:ac/:eleid" element={<SecondRandomization />} />
							<Route path='/AcAllocation/:id/:eid/:ac/:pc/:etype' element={<AcAllocation/>}/>
							<Route path='/PcAllocation/:id/:etype/:ac/:pc/:eid/:distCode' element={<PcAllocation/>}/>
							
							<Route path="/Commissioning" element={<Commissioning />} />
							<Route path="/UnitReplacement" element={<UnitReplacement />} />
							<Route path="/UnitReplacementAgainstSOP" element={<UnitReplacementAgainstSOP />} />
							<Route path='/EVMCheckandVerification' element={<EVMCheckandVerification />} />
							<Route path='/CandVUpdate' element={<CandVUpdate />} />
							<Route path='/EVMCandVRemove' element={<EVMCandVRemove />} />
							<Route path='/EVMViewCandV' element={<EVMViewCandV />} />
							<Route path='/EVMViewCandVFinal' element={<EVMViewCandVFinal />} />
							<Route path="/MandatoryVerificationOfVVPAT" element={<MandatoryVerificationOfVVPAT/>} />
							<Route path="/VVPATView" element={<VVPATView/>} />
							<Route path='/UnitReplacementRollback' element={<UnitReplacementRollback />} />
							<Route path='/NonFunctionalReserveRollback' element={<NonFunctionalReserveRollback />} />
							
							<Route path="/Distributing" element={<Distributing />} />
							<Route path="/Polling" element={<Polling />} />
							<Route path="/Counting" element={<Counting />} />
							<Route path="/Training" element={<Training />} />
							<Route path="/list_T&A" element={<TnAlist />} />
							<Route path="/ChangeUnitStatus" element={<ChangeUnitStatus />} />
							<Route path="/ChangeUnitWarehouseToWarehouse" element={<ChangeUnitWarehouseToWarehouse />} />
							{ (roleCode === "ADM" || roleCode === "ESU" || roleCode === "ECU" || roleCode === "CEO" || roleCode === "COF") ?(<Route path="/ElectionPetition" element={<ElectionPetition />} />):(<Route path="/ElectionPetition" element={<PermissionDenied />} />)}
							{ (roleCode === "ADM" || roleCode === "ESU" || roleCode === "ECU" || roleCode === "CEO" || roleCode === "COF") ?(<Route path="/ElectionPetitionView" element={<ElectionPetitionView />} />):(<Route path="/ElectionPetitionView" element={<PermissionDenied />} />)}
							{ (roleCode === "ADM" || roleCode === "ESU" || roleCode === "ECU" || roleCode === "CEO" || roleCode === "COF") ?(<Route path="/EPMarkDetailedReport" element={<EPMarkDetailedReport />} />):(<Route path="/EPMarkDetailedReport" element={<PermissionDenied />} />)}
							<Route path="/PV" element={<Physicalverificstion />} />
							<Route path="/Others" element={<Others />} />
							<Route path="/ChangeBoxID" element={<ChangeBoxID />} />
							<Route path="/BlockUnits" element={<BlockUnits />} />
							<Route path="/UnBlockUnits" element={<UnBlockUnits />} />
							<Route path="/DestroyUnits" element={<DestroyUnits />} />
							{ ((roleCode === "ADM") || (roleCode === "ESU")) ? (<Route path="/procurement" element={<NewProcurement />} />) : (<Route path="/procurement" element={<PermissionDenied />} />)}
							{/* <Route path="/procurement" element={<NewProcurement />} /> */}
							{/* polling stations commented as randomization completed */}
							{ ((roleCode === "CEO") || (roleCode === "DEO") || (roleCode === "DOF") || (roleCode === "COF")) ? (<Route path="/PollingStation" element={<PollingStation />} />) : (<Route path="/PollingStation" element={<PermissionDenied />} />)}
							{/* <Route path="/PollingStation" element={<PermissionDenied />} /> */}
							{ roleCode !== "WIC" ? (<Route path="/createorder" element={<CreateOrder />} />) : (<Route path="/createorder" element={<PermissionDenied />} />)}
							{ roleCode !== "WIC" ? (<Route path="/createorder/:orderid" element={<CreateOrder />} />) : (<Route path="/createorder/:orderid" element={<PermissionDenied />} />)}
							<Route path="/OrderGeneration" element={<OrderGeneration />} />
							<Route path="/OrderGenerationAll" element={<OrderGenerationAll />} />
							<Route path="/RollBacking" element={<RollBacking />} />
							<Route path="/UnitOrderSearch" element={<UnitOrderSearch />} />
							<Route path="/CheckTransportStatus" element={<CheckTransportStatus />} />
							
							<Route path="/stockorders" element={<StockOrder />} />
							<Route path="/completedorders" element={<Completedorders />} />
							<Route path="/ChangeWarehouse" element={<ChangeWarehouse />} />
							<Route path="/approveorders" element={<OrderApproval />} />
							<Route path="/loanorder/allocation/sender/:orderid/:orderkey/:type" element={<LoanSenderAllocation/>}/>
							<Route path="/allocation/receiver/:orderid/:orderkey/:type" element={<ReceiverAllocation/>}/>
							<Route path="/allocation/sender/:orderid/:orderkey/:type" element={<SenderAllocation/>}/>
							<Route path="/manufacturer/allocation/sender/:orderid/:orderkey/:type" element={<MFASenderAllocation/>}/>
							<Route path="/manufacturer/allocation/receiver/:orderid/:orderkey/:type" element={<MFAReceiverAllocation/>}/>
							{ ((roleCode !== "ADM") || (roleCode !== "ESU")) ? (<Route path="/Allocation" element={<PendingActions />} />) : (<Route path="/Allocation" element={<PermissionDenied />} />)}
							<Route path="/mergeorder" element={<MergeOrder />} />
							<Route path="/OrderHistory" element={<OrderHistory />} />
							<Route path="physicalverification" element={<Physicalverification/>} />	
							{ ((roleCode === "ADM") || (roleCode === "ESU")) ? (<Route path="physicalverification/createphysicalverification" element={<CreateVerification/>} />) : (<Route path="physicalverification/createphysicalverification" element={<PermissionDenied />} />)}
							<Route path="stockentry" element={<UserAssign/>} />
							<Route path="/Consumable" element={<Consumable />} /> 
							<Route path="/Consumable/ExpiredConsumables" element={<ExpiredConsumables />} /> 
							<Route path="/Consumable/ExpiringConsumables" element={<ExpiringConsumables />} /> 
							<Route path="/Consumable/NewStockEntry" element={<NewStockEntry />} /> 
							<Route path="/faq" element={<FAQ />} />
							<Route path="/TentativeElectionSchedule" element={<TentativeElectionSchedule />} />
							<Route path="/warehouseManagement/Create" element={<AddWarehouse />} />
							<Route path="/warehouseManagement/Warehouse" element={<WarehouseList />} />
							<Route path="/warehouseManagement/Strong Room" element={<Strongroom />} />
							<Route path="/RollBacking" element={<RollBacking />} />
							<Route path="/warehouseManagement/AuditDetail/:id" element={<AuditDetail />} />
							<Route path="/warehouseManagement/WarehouseDetail/:id" element={<WarehouseDetail />} />
							<Route path="/warehouseManagement/ModifyWarehouse/:id" element={<ModifyWarehouse />} />
							{ ((roleCode === "ADM") || (roleCode === "ESU") || (roleCode === "CEO") || (roleCode === "COF")) ? 
							(<Route path="/warehouseManagement/Approval" element={<Approval />} />) : (<Route path="/warehouseManagement/Approval" element={<PermissionDenied />} />)}
							<Route path="/createuser" element={<CreateUser />} /> 
							{(roleCode === "ROP" || roleCode === "ROA") ?  (<Route path="/RolesPermissions" element={<PermissionDenied />} />): (<Route path="/UserList/UserList" element={<ManageUsers />} />)}
							<Route path="/UserList/View" element={<ManageUsers />} />
							<Route path="/UserList/Reset" element={<ManageUsers />} />
							<Route path="/IssueRequest/Requestlist" element={<RequestList />} />
							<Route path="/IssueRequest/FaqPage" element={<FaqPage />} />
							<Route path="/schedule " element={<Calendar />} />
							<Route path="/IssueRequest/CreateIssue" element={<CreateIssue />} />
							<Route path="//changepassword" element={<FormPropsTextFields />} />
							<Route path="/GLobalSearch" element={<GLobalSearch />} />
							<Route path="/FLCNonFunctional" element={<FLCNonFunctional />} />
							{roleCode === "ADM" ||
								roleCode === "ECU" ||
								roleCode === "ESU" ||
								roleCode === "CEO" ||
								roleCode === "COF" ||
								roleCode === "SNO" ||
								roleCode === "DOF" ||
								roleCode === "DEO" ||
								roleCode === "DDO" ||
								roleCode === "ROA" || roleCode === "ROP" ? <Route path="/UnitReplacementhistory" element={<UnitReplacementHistory />} /> : ""}
							{roleCode === "ADM" ||
								roleCode === "ECU" ||
								roleCode === "ESU" ||
								roleCode === "CEO" ||
								roleCode === "COF" ||
								roleCode === "SNO" ||
								roleCode === "DOF" ||
								roleCode === "DEO" ||
								roleCode === "DDO" ||
								roleCode === "ROP" ||
								roleCode === "WIC" ||
								roleCode === "ROA" ? <Route path="/ViewBoxInfo" element={<ViewBoxInfo />} /> : ""}

							<Route path="/MoveWHtoWHUnits" element={<MoveWHtoWHUnits />} />
							<Route path="/NRVRollback" element={<NRVRollback />} />
							<Route path="/MasterManagementModule" element={<MasterManagementModule />} />
							<Route path="/OAFLCStatus" element={<OAFLCStatus />} />
							<Route path="/FLCStetewiseStatus" element={<FLCStetewiseStatus />} />
							<Route path='/ElectionDetails' element={<ElectionDetails />} />
							<Route path="/OARandomizationStatus" element={<OARandomizationStatus />} />
							<Route path="/RandDuplicateChecking" element={<RandDuplicateChecking />} />
							<Route path="/ViewUnitReplacementAgainstSoP" element={<ViewUnitReplacementAgainstSoP />} />
							
							{ ((userId === "INALL000ECU51" || userId === "INALL000ECU47" || userId === "INALL000ECU70" || userId === "INALL000ECU62" || userId === "INALL000ECU45" || userId === "INALL000ECU40") || (roleCode === "ESU")) ? (<Route path="/GetOTP" element={<GetOTP />} />) : (<Route path="/GetOTP" element={<PermissionDenied />} />)}
							<Route path="/OverallUnitReplacementStatus" element={<OverallUnitReplacementStatus />} />
							<Route path="/ScanningStatus" element={<ScanningStatus />} />
							{/* <Route path="/EPStatus" element={<EPStatus />} /> */}
							<Route path="/WarehouseInspectionStatus" element={<WarehouseInspectionStatus />} />
							{ (roleCode === "ESU") ? (<Route path="/WarehouseInspectionManage" element={<WarehouseInspectionManage />} />) : (<Route path="/WarehouseInspectionManage" element={<PermissionDenied />} />)}
							<Route path="/NonFunctionalStatus" element={<NonFunctionalStatus/>} />
							<Route path="/RepairedUnitsDetails" element={<RepairedUnitsDetails/>} />
							{/* <Route path="/LoggedUsersStatus" element={<LoggedUsersStatus />} /> */}
							<Route path="/MapData" element={<MapData/>} />
							<Route path="/DispatchedUnits" element={<DispatchedUnits/>} />
							<Route path="/BarCode" element={<BarCode/>} />
							<Route path="/UploadRepairedCertificate" element={<UploadRepairedCertificate/>} />
							<Route path="/Viewrepairedcertificate" element={<Viewrepairedcertificate />} />
							<Route path="/Tracking/personnelRegistration" element={<PersonnelRegistration/>} />
							<Route path="/Tracking/personnelTracking" element={<PersonnelTracking/>} />
							<Route path="/Tracking/vehicleTracking" element={<VehilceTracking/>} />
							<Route path="/Tracking/OptimalMap" element={<OptimalMap/>} />
							<Route path="/Tracking/trackingHistory" element={<TrackingHistory/>} />
							{ ((roleCode === "ADM") || (roleCode === "ESU")) ? (<Route path="/RolesPermissions" element={<RolesPermissions />} />) : (<Route path="/RolesPermissions" element={<PermissionDenied />} />)}
							<Route path="/Allreports" element={<Allreports />} />
							<Route path="/UserReport" element={<UserReport />} />
							<Route path="/WarehouseReport" element={<WarehouseReport />} />
							<Route path="/UnitReport" element={<UnitReport />} />
							<Route path="/ArchiveUnitReport" element={<ArchiveUnitReport />} />
							<Route path="/OrderReport" element={<OrderReport />} />
							<Route path="/IssueReport" element={<IssueReport />} />
							<Route path="/ConsumableReport"  element= {<ConsumableReport/>} />
							<Route path="/ManufacturerReport"  element= {<ManufacturerReport/>} />
							<Route path="/OrderScanningReport"  element= {<OrderScanningReport/>} />
							<Route path="/SenderReport"  element= {<SenderReport/>} />
							<Route path="/ManufacturerWiseReport"  element= {<ManufacturerWiseReport/>} />
							<Route path="/ManufacturerStockYearReport"  element= {<ManufacturerStockYearReport/>} />
							<Route path="/StateWiseNonFunc"  element= {<StateWiseNonFunc/>} />
							<Route path="/FLCScanningReport"  element= {<FLCScanningReport/>} />
							<Route path="/ReceiverReport"  element= {<ReceiverReport/>} />
							<Route path="/StateWiseReport"  element= {<StateWiseReport/>} />
							<Route path="/vieweditmaster"  element= {<ViewEditmaster/>} />	
							<Route path="/AdminUtilities" element={<AdminUtilities />} />
							<Route path="/AdminUtilities/State/Code" element={<StateName/>}/>
							<Route path="/AdminUtilities/District/Code" element={<DistrictData/>}/>
							<Route path="/AdminUtilities/AC/Code" element={<AC/>}/> 
							<Route path="AdminUtilities/PC/Code" element={<PC/>}/>
							<Route path="AdminUtilities/PSList" element={<PSList/>}/>
							<Route path="AdminUtilities/WareHouseType" element={<WareHouseTypes/>}/>
							<Route path="/AdminUtilities/DefectiveTypes" element={<DefectiveTypes/>}/>
							<Route path="/AdminUtilities/unittypesandmodel" element={<Unittypeandmodel />}/>
							{((roleCode === "ADM" || roleCode === "ESU"))?<Route path="/AdminUtilities/DisplayAnnouncement" element={<DisplayAnnouncement />}/>:(<Route path="/AdminUtilities/DisplayAnnouncement" element={<PermissionDenied />} />)}
							<Route path="/AdminUtilities/T&A_Master" element={<TandAMaster />}/>
							<Route path="*" element={<PageNotFound />}/>
            </Routes>
						</Suspense>
					</ErrorBoundary>
        </main>
      </ThemeProvider>
    </ColorModeContext.Provider>
		</>
	)
	{console.log("tests")}
}

export default Routed